import { render, staticRenderFns } from "./CarteView.vue?vue&type=template&id=62356683&scoped=true"
import script from "./CarteView.vue?vue&type=script&lang=js"
export * from "./CarteView.vue?vue&type=script&lang=js"
import style0 from "./CarteView.vue?vue&type=style&index=0&id=62356683&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62356683",
  null
  
)

export default component.exports